import { firstNames, lastNames, streetNames, stateAbbreviations, stateNames, states, citiesByState, wildlifeSpecies } from './constants';
class MockData {
    constructor() {
        this.firstNames = firstNames;
        this.lastNames = lastNames;
        this.streetNames = streetNames;
        this.stateAbbreviations = stateAbbreviations;
        this.stateNames = stateNames;
        this.states = states;
        this.wildlifeSpecies = wildlifeSpecies;
    }
    _birthDayFor(birthMonth) {
        switch (birthMonth) {
            case 0:
            case 2:
            case 4:
            case 6:
            case 7:
            case 9:
            case 11:
                return this._randomNumber(1, 31);
            case 1:
                return this._randomNumber(1, 28);
            default:
                return this._randomNumber(1, 31);
        }
    }
    generateField(type, arg = "") {
        switch (type) {
            case 'BirthDate':
                {
                    let birthYear = this._randomNumber(1930, 2020);
                    let birthMonth = this._randomNumber(0, 11);
                    let birthDay = this._birthDayFor(birthMonth);
                    return new Date(birthYear, birthMonth, birthDay);
                }
            case 'FirstName':
                return this._randomItem(this.firstNames);
            case 'LastName':
                return this._randomItem(this.lastNames);
            case 'Street':
                return `${this._randomNumber(1000, 9999)} ${this._randomItem(this.streetNames)}`;
            case 'City':
                {
                    let cbs = citiesByState[arg];
                    if (!cbs && !arg) {
                        cbs = this._randomItem(this.stateAbbreviations);
                    }
                    if (cbs) {
                        return this._randomItem(citiesByState[arg]);
                    }
                    return null;
                }
            case 'State':
                return this._randomItem(this.states);
            case 'StateName':
                return this._randomItem(this.stateNames);
            case 'StateAbbreviation':
                return this._randomItem(this.stateAbbreviations);
            case 'WildlifeSpecies':
                return this._randomItem(this.wildlifeSpecies);
            case 'PhoneNumber':
                return `(${this._randomNumber(100, 999)}) ${this._randomNumber(100, 999)}-${this._randomNumber(1000, 9999)}`;
            default:
                return null;
        }
    }
    _randomItem(array) {
        return array[Math.floor(Math.random() * array.length)];
    }
    _randomNumber(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }
}
export default MockData;
